import { DataField } from "shared/providers/types";
import { HubspotFieldEditorProps } from "@v2/components/controls/editors/types";
import React, { ReactNode } from "react";
import {
  DateTimeEditor,
  DefaultEditor,
  FieldControlProps
} from "@v2/components/flowsteps/editors/common/filter-editors";
import { isSubstitutionPattern } from "shared/utils/querySubstitution";
import { SelectorValue } from "src/components/Flowsteps/base/FilterManager";
import { Operators } from "@v2/components/flowsteps/editors/salesforce/report/filters/sf-operators";


export const OptionsSelector: React.FC<FieldControlProps> = ({ value, onChange, field, operator }) => {
  const options = field?.options || [];
  const isSubstitution = isSubstitutionPattern(value);

  return (
    <SelectorValue
      isSubstitution={isSubstitution}
      options={options.map(option => ({
        key: option.value,
        text: option.label,
      }))}
      plural={field?.hasMultiselectOptions || (operator && [Operators.IN.operator, Operators.NOTIN.operator].includes(operator))}
      value={value}
      onChange={onChange}
    />
  )
}

const typeEditorMap: {types: string[], component: React.FC<any> | undefined} [] = [
  {
    types: [ 'id', 'reference', 'double', 'int', 'currency', 'percent', 'time', 'string', 'email', 'phone',
      'textarea', 'url'],
    component: DefaultEditor,
  },
  {
    types: ['date', 'datetime'],
    component: DateTimeEditor,
  },
  {
    types: [ 'picklist', 'enumeration', 'multipicklist' ],
    component: OptionsSelector,
  },
  {
    types: [ 'boolean' ],
    component: OptionsSelector,
  },
]

export const renderEditorForTypeAndOperator = (
  field: DataField,
  operator: string,
  props: HubspotFieldEditorProps
): ReactNode => {
  const item = typeEditorMap.find((item) => item.types.includes(field.type));
  const Editor = item?.component || DefaultEditor;
  return <Editor field={field} operator={operator} {...props} />;
}
